import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Role } from "@src/types/user-management";

export interface GetUserResult {
  success: boolean;
  data?: Role[];
  error?: string;
}

export const getValidUserRolesUseCase = async (): Promise<GetUserResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getValidUserRoles(namespace);

    if (response.data.length === 0) {
      return {
        success: false,
        error: "No valid user roles found.",
      };
    }

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to fetch roles. Please try again later.",
      ).message,
    };
  }
};
